import { makeAutoObservable } from 'mobx';
import { apiServiceDepartments } from '../../services/apiService';
import { mapTransformRoomDataToMarker } from '../../helpers/utils';
import { mapStore } from '../Map3d/map.store';
import { RoomData } from '../../types/global.types';
import { CategoryKey } from '../../modules/copia/copia.type';

class SearchRoom {
  searchVal = '';

  rooms: RoomData[] = [];

  renderRooms: RoomData[] = [];

  autoComplete: string[] = [];

  showFilters = false;

  draging = false;

  style: any = {};

  categoryHandlers: any = {
    hotels: {
      apiCall: apiServiceDepartments.getHotels,
    },
    apartments: {
      apiCall: apiServiceDepartments.getApartments,
    },
    constructors: {
      apiCall: apiServiceDepartments.getEstates,
    },
    restaurants: {
      apiCall: apiServiceDepartments.getRestaurants,
    },
  };

  constructor() {
    makeAutoObservable(this);
  }

  setShowFilters = (value: boolean) => {
    this.showFilters = value;
  };

  setRooms = (rooms: any) => {
    this.rooms = rooms;
    this.renderRooms = rooms;
  };

  getRooms = async (category: CategoryKey) => {
    const { apiCall } = this.categoryHandlers[category];
    const cards = await apiCall();
    const data = cards.data?.items || cards.data?.result || [];
    this.setRooms(data);
    const markers = data.map(mapTransformRoomDataToMarker);
    mapStore.setMarkers(markers);
  };

  onDrag = (e: any) => {
    this.draging = true;
    this.style = {
      clientX: e.clientX + 2,
      clientY: e.clientY + 2,
    };
  };

  onDragStart = (e: any) => {
    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('mousemove', this.onDrag);
  };

  onDragEnd = (e: any) => {
    this.style = {};
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('mousemove', this.onDrag);
    this.draging = false;
  };

  onSelect = (val: string) => {
    this.onSearch(val);

    this.autoComplete = [];
  };

  onSearch = (val: string) => {
    this.searchVal = val;

    if (val) {
      const res = this.rooms.filter((room) =>
        room.name.toLocaleLowerCase().includes(val.toLocaleLowerCase()),
      );

      this.renderRooms = res;
      this.autoComplete = res.map((room) => room.name);
    } else {
      this.renderRooms = this.rooms;
      this.autoComplete = [];
    }
  };
}
export const searchStore = new SearchRoom();
